import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useThemeMode} from '../../../../_metronic/partials'
import warningIcon from '../../../../media/billing/ic-warning.svg'
import TickMark from '../../../../media/billing/ic-tickmark.svg'
import {BasicButton} from '../../widgets/components/UI/BasicButton'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'
import {useAuth} from '../../auth'
import brandingConfig from '../../../../config/brandingConfig'
import {comparision, plansRK} from '../core/_constants'

const BillingModalRK = ({
  modalShow,
  setModalShow,
  currentState,
  setCurrentState,
  selected,
  setSelected,
  currencyBill,
  changePlan,
  localBilling,
  setlocalBilling,
  localPlan,
  setlocalPlan,
  billingModalLoading,
  setBillingModalLoading,
}: any) => {
  const {formatMessage} = useIntl()
  const {mode} = useThemeMode()
  const {companyId, billingData, planStatus} = useAuth()
  const [localPrice, setlocalPrice] = useState('0') //eslint-disable-line
  const recommended = 'Gold'
  
  return (
    <>
      <Modal
        fullscreen
        show={modalShow}
        onHide={() => {
          setlocalPlan('')
          setModalShow(false)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpgradeModalClosed,
              metadata: {
                company_id: companyId,
                page_url: `${window.location.origin}/${window.location.pathname}?tab=billing`,
              },
            },
          })
        }}
        aria-labelledby='contained-modal-title-vcenter'
        centered
      >
        <Modal.Header closeButton>
          <div className=' d-flex align-items-center fw-bold'>
            <h2 className='font-size-20'>{formatMessage({id: 'Upgrade to New Plan'})}</h2>
          </div>
        </Modal.Header>
        <Modal.Body className='container' style={{overflowY: 'scroll', scrollbarWidth: 'none'}}>
          <div
            className={`alert mt-4 alert-warning d-flex p-4 gap-4 d-none`}
            style={{color: '#383940', background: `${mode === 'dark' ? '#FFF8DD' : ''}`}}
          >
            <img src={warningIcon} alt='' />
            <div>
              <h1 className='font-size-16 fw-semibold text-black'>
                {formatMessage({id: 'Upgrade Required to Unlock This Feature!'})}
              </h1>
              <p className='font-size-13 fw-medium m-0 text-black'>
                {formatMessage({
                  id: `Your current plan does not include access to this feature. Upgrade now to continue and unlock its full potential, or contact your account or billing administrator for assistance.`,
                })}
              </p>
            </div>
          </div>
          <div className='d-flex flex-md-row flex-column align-items-center justify-content-between py-4'>
            <h1 className='font-size-20 lh-base mb-4 mb-md-0'>
              {formatMessage({id: 'Select a Subscription Plan to Continue'})}
            </h1>
            <div className='d-flex flex-md-row flex-column align-items-center gap-4'>
              <p className='text-primary mb-0'>
                <span className='fw-bold'>{formatMessage({id: '2 Months Free'})}</span>
                {formatMessage({id: ' with Yearly Billing!'})}
              </p>
              <div className='rounded-pill border border-2 d-flex bg-white cursor-pointer'>
                <p
                  className={`mb-0 py-4 px-6 rounded-pill ${
                    localBilling === 'Yearly' ? 'bg-primary text-white ' : ''
                  }`}
                  style={{transition: 'background-color 0.3s ease, color 0.3s ease'}}
                  onClick={() => {
                    // setlocalPlan(plansRK[0].title)
                    billingData?.company_country?.currency === 'INR'
                      ? setlocalPrice(plansRK[0]?.priceAnnualUSD)
                      : setlocalPrice(plansRK[0]?.priceAnnualUSD)
                    setlocalBilling('Yearly')
                  }}
                >
                  {formatMessage({id: 'Yearly'})}
                </p>
                <p
                  className={`mb-0 py-4 px-6 rounded-pill ${
                    localBilling === 'Monthly' ? 'bg-primary text-white ' : ''
                  }`}
                  style={{transition: 'background-color 0.3s ease, color 0.3s ease'}}
                  onClick={() => {
                    // setlocalPlan(plansRK[0].title)
                    billingData?.company_country?.currency === 'INR'
                      ? setlocalPrice(plansRK[0]?.priceMonthUSD)
                      : setlocalPrice(plansRK[0]?.priceMonthUSD)
                    setlocalBilling('Monthly')
                  }}
                >
                  {formatMessage({id: 'Monthly'})}
                </p>
              </div>
            </div>
          </div>
          <div className='d-flex flex-md-row flex-column gap-4 py-4'>
            {plansRK.map((plans: any) => (
              <>
                <div
                  className={`w-md-25 w-100 border border-2 rounded px-4 py-6 d-flex flex-column gap-2 position-relative ${
                    plans.title === selected && currentState === localBilling
                      ? 'border-success'
                      : ''
                  }`}
                >
                  {plans.title === selected && currentState === localBilling && (
                    <div
                      className='position-absolute top-0 end-0 px-6 py-2 border border-2 border-top-0 border-end-0 border-success text-success bg-success bg-opacity-10'
                      style={{borderBottomLeftRadius: '6px'}}
                    >
                      {formatMessage({id: 'Current Plan'})}
                    </div>
                  )}
                  {plans.title === recommended && (
                    <div
                      className={`position-absolute top-0 end-0 px-6 py-2 text-primary bg-primary bg-opacity-10 ${
                        selected === recommended && 'd-none'
                      }`}
                      style={{borderBottomLeftRadius: '6px', borderTopRightRadius: '4.5px'}}
                    >
                      {formatMessage({id: 'Recommended'})}
                    </div>
                  )}
                  <div>
                    <h1 className='font-size-20 lh-base mb-1'>
                      {formatMessage({id: plans.title})}
                    </h1>
                    <p className='text-muted font-size-12 lh-base mb-0' style={{minHeight: '36px'}}>
                      {formatMessage({id: plans.subheader})}
                    </p>
                  </div>
                  <h1 className='d-flex align-items-end mb-0 py-6'>
                    <span className='d-flex font-size-16 mb-1'>
                      {plans.title !== 'Basic'
                        ? billingData?.company_country?.currency === 'INR'
                          ? '$'
                          : '$'
                        : ''}
                    </span>
                    {billingData?.company_country?.currency === 'INR' ? (
                      localBilling === 'Yearly' ? (
                        <p className='font-size-32 mb-0'>
                          {formatMessage({id: plans.priceAnnualUSD})}
                          <span className='font-size-16'>{formatMessage({id: '/Year'})}</span>
                        </p>
                      ) : (
                        <p className='font-size-32 mb-0'>
                          {formatMessage({id: plans.priceMonthUSD})}
                          <span className='font-size-16'>{formatMessage({id: '/Month'})}</span>
                        </p>
                      )
                    ) : localBilling === 'Monthly' ? (
                      <p className='font-size-32 mb-0'>
                        {formatMessage({id: plans.priceMonthUSD})}
                        <span className='font-size-16'>{formatMessage({id: '/Month'})}</span>
                      </p>
                    ) : (
                      <p className='font-size-32 mb-0'>
                        {formatMessage({id: plans.priceAnnualUSD})}
                        <span className='font-size-16'>{formatMessage({id: '/Year'})}</span>
                      </p>
                    )}
                  </h1>
                  <BasicButton
                    buttonText={
                      billingData?.status === 'cancelled' &&
                      plans.title === selected &&
                      currentState === localBilling
                        ? formatMessage({id: 'Reactivate'})
                        : formatMessage({id: 'Buy plan'})
                    }
                    border='none'
                    color='#4776E6'
                    textColor='#FFFFFF'
                    height='44'
                    padding='10px 24px'
                    minWidth={137}
                    onClick={() => {
                      setlocalPlan(plans.title)
                      changePlan(plans.title)
                    }}
                    loading={
                      billingModalLoading &&
                      plans.title === localPlan &&
                      currentState === localBilling
                    }
                    disabled={
                      plans.title === selected &&
                      currentState === localBilling &&
                      planStatus !== 'cancelled'
                    }
                  />
                  <p className='text-center mb-0 font-size-11 mt-2'>
                    {formatMessage({
                      id: `${brandingConfig.freeTrialDays}-day Free Trial. No Credit Card Needed.`,
                    })}
                  </p>
                  {plans.title === 'Personal' ? (
                    <p className='text-primary mb-0 bg-primary bg-opacity-10 border border-primary rounded text-center py-1 mt-4'>
                      {formatMessage({id: 'Personal & Family Use Only'})}
                    </p>
                  ) : (
                    <p className='text-success mb-0 bg-success bg-opacity-10 border border-success rounded text-center py-1 mt-4'>
                      {formatMessage({id: 'Business Use Only'})}
                    </p>
                  )}
                  <p className='font-size-14 mb-2 fw-semibold mt-4'>
                    {formatMessage({id: `${plans.title} Plan Includes:`})}
                  </p>
                  {plans.features.map((feature: any, index: number) => (
                    <div key={index} className='d-flex align-items-center gap-3'>
                      <img src={TickMark} alt='tick mark' height={20} width={20} />
                      <p className='mb-0'>{formatMessage({id: feature.title})}</p>
                    </div>
                  ))}
                </div>
              </>
            ))}
          </div>
          <div className='d-flex flex-md-row flex-column justify-content-between gap-4 py-4'>
            <div className='d-flex flex-column gap-2 w-md-25 w-100 p-4 border border-primary rounded'>
              <h1 className='font-size-20 mb-4 lh-base'>
                {formatMessage({id: 'Did not Find what you are looking for?'})}
              </h1>
              <button className='btn bg-primary custom-button-property text-white'>
                <a
                  className='text-white'
                  href='https://app.apollo.io/#/meet/kfz-9k8-lb3/recordskeeper-demo'
                  target='_blank'
                  rel='noreferrer'
                >
                  {formatMessage({id: 'Lets Connect'})}
                </a>
              </button>
            </div>
            <div
              className='d-flex flex-md-row flex-column gap-4 w-md-75 w-100 justify-content-between align-items-md-center align-items-start p-md-8 p-4 rounded'
              style={{background: 'rgba(37, 57, 111, 1)'}}
            >
              <div className='d-flex flex-column'>
                <h1 className='mb-2 text-white font-size-32 text-start lh-base'>
                  {formatMessage({id: 'Looking for an Enterprise Plan?'})}
                </h1>
                <p className='mb-0 text-white font-size-16 text-start'>
                  {formatMessage({id: 'Unlimited Access to RecordsKeeper.AI'})}
                </p>
              </div>
              <button className='btn bg-success custom-button-property text-white w-100 w-md-auto'>
                <a
                  className='text-white'
                  href='https://app.apollo.io/#/meet/kfz-9k8-lb3/recordskeeper-demo'
                  target='_blank'
                  rel='noreferrer'
                >
                  {formatMessage({id: 'Talk to Sales'})}
                </a>
              </button>
            </div>
          </div>
          <div className='py-4'>
            <div className='accordion border border-2 rounded' id='accordionExample'>
              <div className='accordion-item'>
                <h2 className='accordion-header'>
                  <button
                    className='accordion-button font-size-14 fw-semibold lh-base'
                    type='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#collapseOne'
                    aria-expanded='true'
                    aria-controls='collapseOne'
                  >
                    {formatMessage({id: 'Detailed Subscription Plan Comparison'})}
                  </button>
                </h2>
                <div
                  id='collapseOne'
                  className='accordion-collapse collapse show'
                  data-bs-parent='#accordionExample'
                >
                  <div className='accordion-body'>
                    <div style={{overflowX: 'auto'}}>
                      <table className='table'>
                        <thead>
                          <tr>
                            <td colSpan={2}></td>
                            {comparision.plans.map((plan, index) => {
                              return (
                                <td
                                  key={index}
                                  className={`text-center ${
                                    plan.title === selected ? 'rounded-top' : ''
                                  }`}
                                  style={{
                                    background:
                                      plan.title === selected
                                        ? mode === 'dark'
                                          ? '#0D0D16'
                                          : '#C7FFE2'
                                        : '',
                                  }}
                                >
                                  {plan.title === selected && (
                                    <h1
                                      className='font-size-14 fw-medium mb-0 text-success lh-base'
                                      style={{background: mode === 'dark' ? '#0D0D16' : '#C7FFE2'}}
                                    >
                                      {formatMessage({id: 'Active Plan'})}
                                    </h1>
                                  )}
                                </td>
                              )
                            })}
                          </tr>
                          <tr>
                            <td colSpan={2}></td>
                            {comparision.plans.map((plan, index) => {
                              return (
                                <td key={index} className='px-0 py-0'>
                                  <div
                                    className='mb-0 pt-4 pb-8 text-center'
                                    style={{
                                      background:
                                        plan.title === selected
                                          ? mode === 'dark'
                                            ? '#161621'
                                            : '#E8FFF3'
                                          : '',
                                    }}
                                  >
                                    <h1 className='font-size-16 lh-base'>
                                      {formatMessage({id: plan.title})}
                                    </h1>
                                    <span className='text-muted'>
                                      {formatMessage({id: plan.subheader})}
                                    </span>
                                  </div>
                                </td>
                              )
                            })}
                          </tr>
                        </thead>
                        <tbody className='pb-4'>
                          {comparision.details.map((detail, index) => (
                            <React.Fragment key={index}>
                              <tr>
                                {detail.availability.map((data, availabilityIndex) => (
                                  <td
                                    key={availabilityIndex}
                                    colSpan={availabilityIndex === 0 ? 2 : 1}
                                    className='px-0 py-0'
                                  >
                                    <p
                                      className={`mb-0 py-4 bg-primary bg-opacity-25 fw-bold
                                        ${
                                          availabilityIndex === 0
                                            ? 'text-start rounded-start ps-4'
                                            : 'text-center'
                                        } 
                                        ${
                                          availabilityIndex === detail.availability.length - 1
                                            ? 'rounded-end'
                                            : ''
                                        }
                                      `}
                                      style={{
                                        background:
                                          availabilityIndex > 0 &&
                                          comparision.plans[availabilityIndex - 1].title ===
                                            selected
                                            ? mode === 'dark'
                                              ? '#161621'
                                              : '#E8FFF3'
                                            : '',
                                      }}
                                    >
                                      {formatMessage({id: data})}
                                    </p>
                                  </td>
                                ))}
                              </tr>
                              {detail?.includes?.map((item, includeIndex) => (
                                <tr key={includeIndex} className='border-bottom'>
                                  <td colSpan={2} className='px-4 py-0' style={{minWidth: '320px'}}>
                                    <p className='mb-0 py-4'>{item.title}</p>
                                  </td>

                                  {item?.limits?.map((limit, limitIndex) => (
                                    <td
                                      key={limitIndex}
                                      className='px-0 py-0 bg-transparent'
                                      style={{minWidth: '150px'}}
                                    >
                                      <p
                                        className='mb-0 py-4 text-center'
                                        style={{
                                          background:
                                            limitIndex >= 0 &&
                                            comparision.plans[limitIndex].title === selected
                                              ? mode === 'dark'
                                                ? '#161621'
                                                : '#E8FFF3'
                                              : '',
                                        }}
                                      >
                                        {formatMessage({id: limit})}
                                      </p>
                                    </td>
                                  ))}
                                </tr>
                              ))}
                              <tr>
                                <td className='px-0 py-0' colSpan={2}></td>
                                {comparision.plans.map((plan, planIndex) => (
                                  <td key={planIndex} className='px-0 py-0 rounded-bottom'>
                                    {plan.title === selected && (
                                      <div
                                        className={`mb-0 py-2 
                                         ${
                                           index === comparision.details.length - 1
                                             ? 'rounded-bottom'
                                             : 'border-bottom-0'
                                         }`}
                                        style={{
                                          background:
                                            plan.title === selected
                                              ? mode === 'dark'
                                                ? '#161621'
                                                : '#E8FFF3'
                                              : '',
                                        }}
                                      />
                                    )}
                                  </td>
                                ))}
                              </tr>
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default BillingModalRK
